import { useEffect, useRef } from 'react'
import Intercom from '@intercom/messenger-js-sdk'
import { useUserStore } from '@/store/useUserStore'

const INTERCOM_APP_ID = 'g4b87gt6'

export const IntercomInitializer = () => {
  const userAuthenticated = useUserStore((state) => state.userAuthenticated)
  const bootedRef = useRef(false)

  useEffect(() => {
    if (userAuthenticated) {
      const createdAtUnix = userAuthenticated.created_at
        ? Math.floor(new Date(userAuthenticated.created_at).getTime() / 1000)
        : undefined

      const settings = {
        app_id: INTERCOM_APP_ID,
        user_id: userAuthenticated.user_id,
        name: userAuthenticated.fullName,
        email: userAuthenticated.email,
        created_at: createdAtUnix,
        hide_default_launcher: true,
      }
      console.log('[Intercom] Booting with settings:', settings)
      Intercom(settings)
      bootedRef.current = true
      console.log('[Intercom] Booted successfully')
    } else if (bootedRef.current) {
      Intercom('shutdown')
      bootedRef.current = false
    }
  }, [userAuthenticated])

  return null
}
